<template>
  <div id="modalPortefeuille">
      <form method="POST" action="/scan/save_portfolio">
        <template>
          <div style="width: 100%">
            <input type="hidden" name="_token" :value="token" />
            <input type="hidden" :name="'form[portfolio_id]'" :value="portfolio_id" />
          </div>
        </template>
        <b-row>
          <b-button class="btnCustomSubmit triggerspinner" type="submit">
            Sauvegarder ce portefeuille
          </b-button>
        </b-row>
      </form>
  </div>
</template>
<script>

$(function() {
	$('.triggerspinner').click(function(){
		$('#overlay').fadeIn();
	});
});

export default {
  props: ["portfolio_id", "token"],
  data() {
    return {
        form: [],
    }
  },
  computed: {
    rows() {
      return this.sec.length;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";


</style>